module.exports = __webpack_public_path__ + "img/upcoming-events_super-bowl.22f61fcf.jpg";